import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Stack,
  Text,
  Textarea,
  Tooltip,
  useClipboard,
  useColorModeValue,
  useToast,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import {
  BsGithub,
  BsLinkedin,
  BsPerson,
  BsFillTelephoneFill,
} from "react-icons/bs";
import { MdEmail, MdOutlineEmail } from "react-icons/md";

import emailjs from "@emailjs/browser";

import "./Contact.css";

const Contact = () => {
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMessage, setUserMessage] = useState("");
  const { hasCopied, onCopy } = useClipboard("kiranwankhade7738@gmail.com");

  const [btnActive, setBtnActive] = useState(false);
  const toast = useToast();

  const contactSubmit = () => {
    if (userName !== "" && userEmail !== "" && userMessage !== "") {
      let params = {
        name: userName,
        email: userEmail,
        message: userMessage,
      };

      emailjs
        .send(
          "service_8yx7232",
          "template_riojqie",
          params,
          "zwpXuaNM4QRr8TvVY"
        )
        .then(
          function (response) {
            console.log("SUCCESS!", response.status, response.text);
            toast({
              title: "Message Sent",
              status: "success",
              position: "top-right",
              isClosable: "true",
            });
          },
          function (err) {
            console.log("FAILED...", err);
          }
        );
      setUserName("");
      setUserEmail("");
      setUserMessage("");
    } 
    else
    {
      toast({
        title: "Please Fill all values",
        status: "error",
        position: "top-right",
        isClosable: "true",
      });
    }
  };

  return (
    <>
      <hr
        className="hrClass"
        style={{
          height: 5,
          backgroundColor: "#29242a",
        }}
      />
      <Box id="contact" className="contact">
        <Box>
          <Heading
            textDecoration={"underline"}
            fontSize={50}
            textUnderlineOffset="10px"
            textDecorationStyle={"solid"}
            textDecorationColor={"orange"}
            color={"#15110D"}
          >
            Contact Me{" "}
          </Heading>
          <br />
        </Box>
        <div id="contactBox">
          <div
            id="mainBox"
            // borderRadius="lg"
            // bg={'#3b3228'}
            m={{ base: 4, md: 16, lg: 10 }}
            p={{ base: 5, lg: 8 }}
          >
            <Box>
              {/* <VStack spacing={{ base: 4, md: 8, lg: 20 }}> */}
              <div
                id="flexBox"
                spacing={{ base: 4, md: 8, lg: 10 }}
                direction={{ base: "column", md: "row" }}
              >
                <div
                  id="contactFlex"
                  // width={{ base: 'container.lg',md:'container.sm' , sm:'80%'}}
                  // bg={useColorModeValue('white', 'gray.700')}
                  // border='5px solid #3b3228'
                  // borderRadius="lg"
                  // p={8}
                  // color={useColorModeValue('gray.700', 'whiteAlpha.900')}
                  // shadow="base"
                >
                  <VStack spacing={5}>
                    <FormControl isRequired>
                      <FormLabel>Name</FormLabel>

                      <InputGroup>
                        <InputLeftElement children={<BsPerson />} />
                        <Input
                          style={{
                            border: "1px solid gray",
                          }}
                          type="text"
                          name={userName}
                          value={userName}
                          placeholder="Your Name"
                          onChange={(e) => setUserName(e.target.value)}
                          isRequired
                        />
                      </InputGroup>
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>Email</FormLabel>

                      <InputGroup>
                        <InputLeftElement children={<MdOutlineEmail />} />
                        <Input
                          type="email"
                          name={userEmail}
                          value={userEmail}
                          placeholder="Your Email"
                          style={{
                            border: "1px solid gray",
                          }}
                          onChange={(e) => setUserEmail(e.target.value)}
                          isRequired
                        />
                      </InputGroup>
                    </FormControl>

                    <FormControl isRequired>
                      <FormLabel>Message</FormLabel>

                      <Textarea
                        name={userMessage}
                        value={userMessage}
                        placeholder="Your Message"
                        rows={6}
                        resize="none"
                        style={{
                          border: "1px solid gray",
                        }}
                        onChange={(e) => setUserMessage(e.target.value)}
                        isRequired
                      />
                    </FormControl>

                    <Button
                      background="orange"
                      color={"black"}
                      fontWeight="bold"
                      marginTop={2}
                      _hover={{ color: "black", bg: "yellow" }}
                      onClick={contactSubmit}
                      isFullWidth
                      isDisabled={btnActive ? true : false}
                    >
                      Send Message
                    </Button>
                  </VStack>
                </div>
                {/* <br /> */}
                <div id="contactStack">
                  <Link
                    to="#"
                    onClick={(e) => {
                      // window.location.href = "mailto:kiranwankhade7738@gmail.com";

                      toast({
                        title: hasCopied ? "Email Copied!" : "Copy Email",
                        status: "success",
                        position: "top-right",
                        isClosable: "true",
                      });
                      e.preventDefault();
                    }}
                    target="_blank"
                    wordBreak="break-all"
                    _hover={{
                      textDecoration: "none",
                    }}
                    fontSize={19}
                  >
                    <Tooltip
                      label={hasCopied ? "Email Copied!" : "Copy Email"}
                      closeOnClick={false}
                      hasArrow
                    >
                      <IconButton
                        aria-label="email"
                        variant="ghost"
                        size="lg"
                        fontSize="3xl"
                        icon={<MdEmail />}
                        _hover={{
                          bg: "yellow",
                          color: useColorModeValue("black", "gray.700"),
                        }}
                        onClick={onCopy}
                        isRound
                      />
                    </Tooltip>
                    kiranwankhade7738@gmail.com
                  </Link>

                  <Link
                    href="tel:7385091483"
                    target="_blank"
                    _hover={{
                      textDecoration: "none",
                    }}
                    fontSize={19}
                  >
                    <IconButton
                      aria-label="github"
                      variant="ghost"
                      size="lg"
                      fontSize="3xl"
                      icon={<BsFillTelephoneFill />}
                      _hover={{
                        bg: "yellow",
                        color: useColorModeValue("black", "gray.700"),
                      }}
                      isRound
                    />
                    +91 7385091483
                  </Link>

                  <Link
                    href="https://github.com/kiranwankhade"
                    _hover={{
                      textDecoration: "none",
                    }}
                    target="_blank"
                    fontSize={19}
                  >
                    <IconButton
                      aria-label="github"
                      variant="ghost"
                      size="lg"
                      fontSize="3xl"
                      icon={<BsGithub />}
                      _hover={{
                        bg: "yellow",
                        color: useColorModeValue("black", "gray.700"),
                      }}
                      isRound
                    />{" "}
                    @kiranwankhade
                  </Link>

                  <Link
                    href="https://www.linkedin.com/in/kiranwankhade/"
                    target="_blank"
                    _hover={{
                      textDecoration: "none",
                    }}
                    fontSize={19}
                  >
                    <IconButton
                      aria-label="linkedin"
                      variant="ghost"
                      size="lg"
                      icon={<BsLinkedin size="28px" />}
                      _hover={{
                        bg: "yellow",
                        color: useColorModeValue("black", "gray.700"),
                      }}
                      isRound
                    />
                    @kiranwankhade
                  </Link>
                </div>
              </div>
              {/* </VStack> */}
            </Box>
          </div>
        </div>
      </Box>
    </>
  );
};

export default Contact;
